var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-three-fifth-tablet is-half-desktop is-offset-one-fifth-tablet is-offset-one-quarter-desktop"},[(_vm.sent)?_c('sent'):_c('contact-form',{on:{"sent":_vm.setSent}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }